import { IGioCongDongHoatDongSelectRequest } from "../../../models/request/gio-cong-dong/IGioCongDongHoatDongSelectRequest";
import { IGioCongDongHoatDongAddOrEdit } from "../../../models/response/gio-cong-dong/IGioCongDongHoatDongAddOrEdit";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";
import { IGioCongDongHoatDongVm } from './../../../models/response/gio-cong-dong/IGioCongDongHoatDong';
export const objGioCongDongHoatDongDefine = {
    LOAD_START: {} as IGioCongDongHoatDongSelectRequest,
    LOAD_SUCCESS: [] as IGioCongDongHoatDongVm[],
    LOAD_ERROR: "",

    LOAD_DETAIL_START: 0,
    LOAD_DETAIL_SUCCESS: {} as IGioCongDongHoatDongAddOrEdit | undefined,
    LOAD_DETAIL_ERROR: "",

    SAVE_START: {} as IGioCongDongHoatDongAddOrEdit,
    SAVE_SUCCESS: 0,
    SAVE_ERROR: "",

    DELETE_START: 0,
    DELETE_SUCCESS: undefined,
    DELETE_ERROR: "",


};

export const eGioCongDongHoatDongActionTypeIds = generateActionTypeIds(objGioCongDongHoatDongDefine, "GIO_CONG_DONG_HOAT_DONG")
export type IGioCongDongHoatDongActionTypes = IGenericActionType<typeof objGioCongDongHoatDongDefine, "GIO_CONG_DONG_HOAT_DONG">
